<template>
  <div class="pay-bread">
    <!-- 面包屑 -->
    <shBread>
      <shBreadItem to="/">首页</shBreadItem>
      <shBreadItem><div class="bread">支付中心</div></shBreadItem>
    </shBread>
  </div>
  <div class="wrap">
    <div class="success" v-if="tradeStatus">
      <h3>
        订单支付成功、<span>{{ timeDuwn }}</span> 秒后跳转到个人中心页面
      </h3>
    </div>
    <div class="fail" v-else>
      <h3>订单支付失败,点击跳转到<a href="">支付页面</a></h3>
    </div>
  </div>
</template>

<script>
import { aliPayOrderPayment } from "@/api/order";
import { useRoute, useRouter } from "vue-router";
import { ref, onUnmounted } from "vue";
import { ElMessage } from "element-plus";
import { usePayTime } from "@/hooks";

export default {
  setup() {
    const tradeStatus = ref(false);
    const route = useRoute();
    const router = useRouter();
    const timeDuwn = ref(5);
    //const timer = ref(null);
    // 倒计时工具函数

    aliPayOrderPayment({
      out_trade_no: route.query.out_trade_no,
      trade_no: route.query.trade_no,
    })
      .then((result) => {
        if (result.data.code == 2) {
          tradeStatus.value = true;
          ElMessage({
            message: result.data.msg,
            type: "success",
          });
          timer;
        } else {
          ElMessage.error(result.data.msg);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    const timer = setInterval(() => {
      timeDuwn.value--;
      if (timeDuwn.value <= 0) {
        router.push("/user/mine");
        clearInterval(timer);
      }
    }, 1000);
    onUnmounted(() => {
      clearInterval(timer);
    });
    return { tradeStatus, timeDuwn };
  },
};
</script>

<style lang="less" scoped>
.pay-bread {
  background: @shColor;
  .bread {
    width: 700px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.wrap {
  width: 1240px;
  margin: 20px auto;
}
</style>
